import {
  ProForm,
  ProFormTextArea,
  ProFormText,
  ProFormSelect,
} from "@ant-design/pro-components";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, message, Form } from "antd";
import { useState, useMemo, useEffect } from "react";
import { OUTSTANDING } from "@/enums/pageEnum";
import { getTimeToString } from "@/utils/toolt";
import Status from "../Status";
import { LIFT_FAULT_CODE } from "./code";

const Report = ({
  data,
  onSubmit,
  fieldsKeys,
  request,
}: {
  data: any;
  onSubmit?: () => void;
  fieldsKeys: any;
  request?: (params: any) => Promise<any>;
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue(data);
  }, [data, form]);

  const operStatus = useMemo(() => {
    return data?.operationalStatus !== OUTSTANDING || data?.reportAt;
  }, [data]);
  return (
    <ProForm
      submitter={false}
      form={form}
      className="draerClass"
      onFinish={async (values) => {
        if (!request) return;
        setLoading(true);
        try {
          await request({ id: parseInt(id || ""), ...values });
          onSubmit?.();
          message.success(t("success"));
          setLoading(false);
        } catch (error: any) {
          setLoading(false);
          message.error(error || "Fail!", 2.5);
        }
      }}
    >
      <div className="border border-[#E8E9ED] dark:border-[#ffffff21] px-6 py-5">
        <div className="text-[16px] font-medium pb-7">{t("repo")}</div>
        <div className="flex justify-start pb-8">
          <div className="flex-1">
            {t("status")}: <Status status={data?.operationalStatus} />
          </div>
          <div className="flex-1">
            {t("acknowTime")}:
            <span className="float-right">
              {getTimeToString(data?.acknowledgeAt)}
            </span>
          </div>
        </div>
        <div className="flex justify-between pb-5">
          <div className="flex-1">
            <div className="flex justify-start">
              <div className="w-[130px] leading-8">
                {t(fieldsKeys["code"])}:
              </div>
              <div className="flex-1">
                <ProFormSelect
                  options={LIFT_FAULT_CODE}
                  name={fieldsKeys["code"]}
                  label=""
                  fieldProps={{
                    style: {
                      width: 180,
                    },
                    popupClassName: "codeClassName",
                    placeholder: "",
                    showSearch: true,
                    labelRender: (props: any) => <>{props.value}</>,
                    optionRender: (option: any) => (
                      <>
                        {option.value} - {option.label}
                      </>
                    ),
                  }}
                  disabled={operStatus}
                />
              </div>
            </div>
          </div>
          <div className="flex-1 leading-8">
            {t("arrivalTime")}:{" "}
            <span className="float-right">
              {getTimeToString(data?.arrivalTs)}
            </span>
          </div>
        </div>
        <div className="flex justify-between pb-6">
          <div className="flex-1">
            <div className="flex justify-start">
              <div className="w-[130px] leading-8">
                <span className="text-[#b5242c] text-[20px] float-left pt-1 pr-1">
                  *
                </span>
                {t(fieldsKeys["name"])}:
              </div>
              <div className="flex-1">
                <ProFormText
                  name={fieldsKeys["name"]}
                  fieldProps={{
                    style: {
                      width: 180,
                    },
                    placeholder: "",
                  }}
                  disabled={operStatus}
                  rules={[{ required: true }]}
                />
              </div>
            </div>
          </div>
          <div className="flex-1 leading-8">
            {t("reportTime")}:{" "}
            <span className="float-right">
              {getTimeToString(data?.reportAt)}
            </span>
          </div>
        </div>
        <ProFormTextArea
          name={fieldsKeys["result"]}
          label={`${t("result")}: `}
          disabled={operStatus}
          rules={[{ required: true, message: "Please enter result" }]}
          fieldProps={{ rows: 2, placeholder: "", maxLength: 2000 }}
        />
        <div className="text-right mt-8">
          <Button
            type="primary"
            loading={loading}
            disabled={operStatus}
            onClick={() => {
              form.submit?.();
            }}
          >
            {t("submit")}
          </Button>
        </div>
      </div>
    </ProForm>
  );
};

export default Report;
